import useScreenSize from '../../hooks/useScreenSize'
import MediumScreenFooter from './MediumScreenFooter/MediumScreenFooter'
import SmallScreenFooter from './SmallScreenFooter/SmallScreenFooter'
import EmailSignupSection from '../../pages/HomePage/Components/EmailSignupSection/EmailSignupSection'

export default function FooterSection({
  showEmailSignup = true,
}: {
  showEmailSignup?: boolean
}) {
  const isMediumScreen = useScreenSize('md')

  return (
    <>
      {showEmailSignup && <EmailSignupSection />}
      {isMediumScreen ? <MediumScreenFooter /> : <SmallScreenFooter />}
    </>
  )
}
